import React from "react";
import { useParams, Outlet } from "react-router-dom";
import { StoreProvider } from "@/context/StoreContext";
import { CartProvider } from "@/context/CartContext";
import { CustomerProvider } from "@/context/CustomerContext";

export default function StorefrontLayout() {
  const { slug } = useParams();
  return (
    <StoreProvider slug={slug}>
      <CartProvider slug={slug}>
        <CustomerProvider slug={slug}>
          <Outlet />
        </CustomerProvider>
      </CartProvider>
    </StoreProvider>
  );
}
